import { fetchSameOrigin } from '../Utils';

const resetPassword = (memberId, password) => {
  const url = `/manage/member/${memberId}/person_password_update.json`;
  const passwordConfirmation = password;
  const resetPasswordFlg = 'Y';
  return fetchSameOrigin(url, 'POST', { body: JSON.stringify({
    password_update: {
      reset_password_flg: resetPasswordFlg,
      password: password,
      password_confirmation: passwordConfirmation
    }
  })}).then(r => Promise.all([Promise.resolve(r.status), r.json()]))
      .then(([status, body]) => {
        if (status !== 200) {
          return Promise.resolve({error: body.message[0]})
        } else {
          return Promise.resolve({})
        }
      }).catch((error) => {
        return Promise.resolve({error: error.message});
      });
};

export default resetPassword;
